<template>
  <div>
    <!--机型列表-->
    <van-list
      v-show="!phoneLoading"
      :class="['phone-list-wrapper pxstrict', hasTab ? 'has-tab' : '']"
      v-model="loading"
      :finished="finished"
      finished-text=""
      :immediate-check="immediateCheck"
      loading-text="loading..."
      @load="onLoad"
    >
      <div
        class="phone-item"
        :key="item.productId"
        v-for="(item, index) in data"
        @click="goPage(item.productId)"
      >
        <!-- <img v-if="index === 0" src="../../../assets/image/product/one.png" alt="">
        <img v-else-if="index === 1" src="../../../assets/image/product/two.png" alt="">
        <img v-else-if="index === 2" src="../../../assets/image/product/three.png" alt=""> -->
        <span
          class="order"
          >{{ index + 1 }}</span
        >
        <span class="title">{{ item.productName }}</span>
      </div>
    </van-list>
    <!-- 机型列表为空时 -->
    <empty v-if="!phoneLoading && data.length === 0"></empty>
    <!--机型列表骨架屏-->
    <van-skeleton
      class="phone-list-skeleton pxstrict"
      :class="{ 'has-tab': hasTab }"
      title
      :row="1"
      title-width="60%"
      row-width="[100%]"
      :loading="phoneLoading"
    />
  </div>
</template>

<script>
import { List } from "vant";
import Empty from "./empty";
export default {
  props: ["data", "hasTab", "finished", "phoneLoading"],
  data() {
    return {
      loading: false,
      immediateCheck: false,
      pageSize: 30,
      currentPage: 1,
    };
  },
  components: {
    "van-list": List,
    Empty,
  },
  methods: {
    /**
     * 显示加载中
     */
    showLoading() {
      this.loading = true;
    },
    /**
     * 加载结束
     */
    hideLoading() {
      this.loading = false;
    },
    /**
     * 跳转至设备属性页面
     * @param id
     */
    goPage(id) {
      const qrcode = this.$route.query.qrCode
      let query = { id, qrcode }
      this.$router.push({
        name: "Property",
        query: query
      });
    },
    /**
     * 上拉加载
     */
    onLoad() {
      this.$emit("onLoad");
    },
  },
};
</script>

<style lang="less" scoped>
.phone-list-wrapper.pxstrict{
	padding-top: 150px;
}
.phone-list-wrapper {
  margin-left: 188px;
  min-height: 100vh;
  .phone-item {
    display: flex;
    align-items: center;
    height: 96px;
    margin: 0 16px 16px 16px;
    background: #fff;
    border-radius: 16px;
    font-size: 28px;
    padding: 14px 28px;
    box-sizing: border-box;
    img {
      width: 48px;
      height: 48px;
      margin-right: 12px;
    }
    .order {
      padding: 0 16px;
      box-sizing: border-box;
      height: 19px;
      line-height: 19px;
      color: #CCC;
      margin-right: 12px;
      font-size: 28px;
      font-weight: 700;
    }
    .tag {
      width: 70px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      color: #ff592c;
      background: #fff5f4;
      border-radius: 5px;
      margin-left: 10px;
      font-size: 14px;
    }
    .title {
      width: 426px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
    }
  }
}
.phone-list-wrapper.pxstrict.has-tab {
  padding-top: 99px;
}
.phone-list-skeleton.pxstrict {
  position: fixed;
  top: 15px;
  left: 100px;
  right: 0;
  bottom: 0;
}
.phone-list-skeleton.pxstrict.has-tab {
  top: 65px;
}
/*重置van-skeleton样式*/
.van-skeleton.pxstrict {
  margin-top: 54px;
}
</style>
